import { Calendar } from 'lucide-react';
import InnerLoader from '../ui/loader/inner-loader';
import DataNotFound from '../ui/loader/data-not-found';
import { ChartMainCard } from '../LeadsDashboardComponents/ChartsHeader';
import { TeamAvailability } from '../LeadsDashboardComponents/StatCardIcons';

const stages = [
  { name: 'Marketing', count: '7,898', value: '$5,221,45', percentage: 100, color: 'bg-[#f26522]' },
  { name: 'Sales', count: '4,658', value: '$30,424', percentage: 86, color: 'bg-[#f37438]' },
  { name: 'Email', count: '8,898', value: '$21,135', percentage: 72, color: 'bg-[#f5844e]' },
  { name: 'Chat', count: '789', value: '$15,235', percentage: 58, color: 'bg-[#f69364]' },
  { name: 'Operational', count: '655', value: '$10,557', percentage: 44, color: 'bg-[#f7a37a]' },
  { name: 'Calls', count: '454', value: '', percentage: 30, color: 'bg-[#f9b291]' },
];

const stageColors = [
  "bg-[#f26522]",
  "bg-[#f37438]",
  "bg-[#f5844e]",
  "bg-[#f69364]",
  "bg-[#f7a37a]",
  "bg-[#f9b291]"
];

export function DealsPipelineStages({ apiData = [], apiLoading }) {
  const hasData = apiData && apiData.length > 0;

  return (
    <ChartMainCard
      Icon={<TeamAvailability />}
      iconColor={'bg-theme-orange-light text-theme-orange'}
      heading="Revenue Funnel Analysis"
      subHeading={"Deal count and amount distribution by sales stage"}
    >
      {!apiLoading ? (
        <div className="p-6 flex-1">
          {/* Horizontal Funnel Chart */}
          {hasData ? (
            <>
              <div className="mb-6 space-y-1 h-[260px] flex flex-col justify-center w-[80%] mx-auto">
                {apiData?.map((stage, idx) => {
                  const percentages = [94, 84, 75, 66, 58];
                  const width = percentages[idx] !== undefined
                    ? `${Math.min(percentages[idx], 100)}%`
                    : "0%";
                  return (
                    <div
                      key={idx}
                      className={`${stageColors[idx % stageColors.length]} flex items-center justify-center py-3 text-white font-medium text-sm transition-all duration-300 fummal`}
                      style={{
                        width,
                        marginLeft: "auto",
                        marginRight: "auto",
                        clipPath: "polygon(0 0, 100% 0, 95% 100%, 6% 99%)"
                      }}
                    >
                      {stage.stage} : {stage.count}
                    </div>
                    // <svg>
                    //   <path fill="rgb(219,233,255)" d="M 0 0 L 366 0 L 340.38 55 L 25.620000000000005 55 Z" borderRadius="0" transform="translate(0,0)" stroke="#ffffff" stroke-width="8" opacity="1" stroke-linejoin="round" class="highcharts-point highcharts-color-0" tabindex="-1" role="img" aria-label="Leads, 1,340. Funnel." ></path>
                    // </svg>
                  )
                })}
              </div>

              {/* Leads Values By Stages */}
              <div>
                <h6 className="mb-3 font-semibold text-base">Leads Values By Stages</h6>
                <div className="grid grid-cols-2 lg:grid-cols-5 gap-2">
                  {apiData?.map((stage, idx) => (
                    <div key={idx} className="border border-gray-200 rounded-lg p-2 text-center">
                      <p className="text-xs mb-1 flex items-center justify-center gap-1">
                        <span className="w-2 h-2 rounded-full bg-blue-600"></span>
                        {stage.stage}
                      </p>
                      <h6 className="text-sm font-semibold">${stage.total_value}</h6>
                    </div>
                  ))}
                </div>
              </div>
            </>
          ) :
            <DataNotFound title={"Deals"} />
          }

        </div>
      ) :
        <InnerLoader />
      }

    </ChartMainCard>




  );
}